"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var matchFieldArrayMemberKey = function matchFieldArrayMemberKey(fieldKey) {
  return fieldKey.match(/(.*)\[(\d+)\].(.*)/) || [];
};

var getField = function getField(fields, fieldKey) {
  var _matchFieldArrayMembe = matchFieldArrayMemberKey(fieldKey),
      _matchFieldArrayMembe2 = _slicedToArray(_matchFieldArrayMembe, 4),
      arrayKey = _matchFieldArrayMembe2[1],
      index = _matchFieldArrayMembe2[2],
      memberKey = _matchFieldArrayMembe2[3];

  return memberKey ? fields[arrayKey][index][memberKey] : fields[fieldKey];
};

exports.default = getField;


//////////////////
// WEBPACK FOOTER
// ./node_modules/form-metadata-2/dist/getField.js
// module id = 284
// module chunks = 0